export default "__VITE_ASSET__Dy1ISFGY__"